import styled from "styled-components"
import TableHeader from "../Ui/Table/TableHeader"

export const StyledTableHeader = styled(TableHeader)`
  padding: 0 2rem 0 10rem;
  border-radius: 0.8rem 0.8rem 0 0;
  background-color: ${(p) => p.theme.colors.greyLighter};
  color: ${(p) => p.theme.colors.black};

  > div {
    height: auto;
    min-height: 4rem;
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
  }

  > div:nth-child(2) {
    flex: 2;
  }

  > div:nth-child(5) {
    flex: 0.6;
  }

  > div:nth-child(8) {
    flex: 1.5;
  }

  > div.compactColumn {
    flex: 0.6;
  }
`

export const ProductsTableContainer = styled.div`
  width: 100%;

  /* Target the TableRow content divs to match header widths */
  > div > div > div:nth-child(3) {
    flex: 2 !important;
  }

  > div > div > div:nth-child(6) {
    flex: 0.6 !important;
  }

  > div > div > div:nth-child(9) {
    flex: 1.5 !important;
  }

  > div > div > div.compactColumn {
    flex: 0.6 !important;
  }
`

